import React, { useEffect, useState } from 'react';
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import './index.css';
import { NumberCardBlock, SingleCountBlock } from '../../../Components/Card';
import { DashBoardTitle } from '../../../Components/Title';
import {
  getdealerActiveInactiveCount,
  getdealerCount,
  getdealerEngagement,
  getMettingCount,
  getOrderSummaryCount,
  getPerformanceInsight,
  getSuccessors,
} from '../../../constants/apiCalls';
import moment from 'moment-timezone';
import classnames from 'classnames';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import { useNavigate, useLocation } from 'react-router-dom';
import ModalService from '../../../services/ModalService';
import Storage from '../../../services/Storage';
import { Roles } from '../../../constants/Roles';
import { handleErrorMessage } from '../../../utils/utils';
import ThemeOptions from '../../../Layout/ThemeOptions';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

let getFinancialYear = () => {
  let minYear = 2018;
  let year =
    moment()
      .tz('Asia/Kolkata')
      .month() +
      1 <=
      3
      ? moment()
        .tz('Asia/Kolkata')
        .year() - 1
      : moment()
        .tz('Asia/Kolkata')
        .year();
  const currentFinancialYear = `${year}-${`${year + 1}`.slice(2, 4)}`;
  const yearOptions = [`${minYear}-${`${minYear + 1}`.slice(2, 4)}`];
  const counts = year - minYear;
  for (let index = 0; index < counts; index++) {
    minYear += 1;
    yearOptions.push(`${minYear}-${`${minYear + 1}`.slice(2, 4)}`);
  }
  return {
    currentFinancialYear,
    yearOptions,
  };
};

const Dashboard = () => {
  let userInfo = Storage.getUserInfoDetail();
  let userId = userInfo ? userInfo.id : null;
  let roleName = userInfo ? userInfo.role : '';
  let userUUID = userInfo ? userInfo.uuid : '';
  const location = useLocation();
  let stringArr = location.pathname.split(/(\d+)/);

  const [year, setYear] = useState(Storage.getDashboardFYYear() ? Storage.getDashboardFYYear()
    : getFinancialYear().currentFinancialYear.split('-')[0]
  );
  const [day, setDay] = useState(Storage.getDashboardCurrentDate() || Storage.getDashboardCurrentDate() === '' ? Storage.getDashboardCurrentDate() : moment(new Date()).format('YYYY-MM-DD'));
  const [selectedFirstDate, setSelectedFirstDate] = useState(Storage.getDashboardCurrentFirstDate() ||
    Storage.getDashboardCurrentFirstDate() === '' ? Storage.getDashboardCurrentFirstDate() : `${moment(day).format('YYYY')}-${moment(day).format('MM')}-01`);
  const [selectedLastDate, setSelectedLastDate] = useState(Storage.getDashboardCurrentLastDate() ||
    Storage.getDashboardCurrentLastDate() === '' ? Storage.getDashboardCurrentLastDate() : `${moment(day).format('YYYY')}-${moment(day).format('MM')}-${moment(day, 'YYYY-MM-DD').endOf('month').format('D')}`);

  const [activeTab, setActiveTab] = useState('1');
  const [isLoading, setIsloading] = useState(false);

  const [meetingCountOpen, setMettingCountOpen] = useState({ ftd: 0, mtd: 0 });
  const [meetingCountHistory, setMettingCountHistory] = useState({
    ftd: 0,
    mtd: 0,
  });
  const [dealerCount, setDealerCount] = useState({
    approve: 0,
    pipeline: 0,
    reject: 0,
  });

  const [orderCount, setOrderCount] = useState({ ftd: 0, mtd: 0 });

  const [dealerEngagement, setDealerEngagement] = useState({
    bday: 0,
    mAnniversary: 0,
    wAnniversary: 0,
  });
  const [dealerActiveInactiveCount, setDealerActiveInactiveCount] = useState({
    active: 0,
    inactive: 0,
  });

  // performance

  const monthArr = [
    { id: 1, monthName: 'January', monthYear: parseInt(year) + 1 },
    { id: 2, monthName: 'February', monthYear: parseInt(year) + 1 },
    { id: 3, monthName: 'March', monthYear: parseInt(year) + 1 },
    { id: 4, monthName: 'April', monthYear: parseInt(year) },
    { id: 5, monthName: 'May', monthYear: parseInt(year) },
    { id: 6, monthName: 'June', monthYear: parseInt(year) },
    { id: 7, monthName: 'July', monthYear: parseInt(year) },
    { id: 8, monthName: 'August', monthYear: parseInt(year) },
    { id: 9, monthName: 'September', monthYear: parseInt(year) },
    { id: 10, monthName: 'October', monthYear: parseInt(year) },
    { id: 11, monthName: 'November', monthYear: parseInt(year) },
    { id: 12, monthName: 'December', monthYear: parseInt(year) },
  ];

  const [performanceMonthId, setPerformanceMonthId] = useState(
    new Date().getMonth() + 1
  );
  const [performanceYearId, setPerformanceYearId] = useState(parseInt(year));

  const [performanceyearArr, setPerformanceyearArr] = useState([
    { id: parseInt(year), yearName: parseInt(year) },
    { id: parseInt(year) + 1, yearName: parseInt(year) + 1 },
  ]);

  let filterMonthArr = monthArr.filter(elem => elem.monthYear === parseInt(performanceYearId));

  useEffect(() => {
    if (new Date().getFullYear() === parseInt(year) || (new Date().getFullYear() - 1) === parseInt(year)) {
      setPerformanceYearId(new Date().getFullYear());
      setPerformanceMonthId(new Date().getMonth() + 1)
    } else {
      setPerformanceMonthId(4)
    }
  }, [])

  const [fYArr, setFYArr] = useState([]);

  const [prUser, setPruser] = useState([]);
  const [prUserId, setPruserId] = useState(userUUID);

  const [performance, setPerformance] = useState({});
  const [workingDay, setWorkingDay] = useState('');
  const [balanceday, setbalanceDay] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    Storage.removeOpenMeetingPage();
    Storage.removeMeetingHistoryPage();
    Storage.removePipelinePage();
    Storage.removeAppprovePage();
    Storage.removeRejectPage();
    Storage.removeOrderPage();
    Storage.removeBirthdayPage();
    Storage.removeMAnniversaryPage();
    Storage.removeWorkAnniversaryPage();
    Storage.removeDealerListPage();
  }, []);

  useEffect(() => {
    setFYArr(getFinancialYear().yearOptions);
  }, []);

  useEffect(() => {
    setIsloading(true);
    getAllDate();
    getDashboardData();
  }, [year, day, selectedFirstDate, selectedLastDate]);

  const getAllDate = () => {
    Storage.setDashboardFYYear(year);
    Storage.setDashboardCurrentDate(day);
    Storage.setDashboardCurrentFirstDate(selectedFirstDate);
    Storage.setDashboardCurrentLastDate(selectedLastDate);
  };

  const getDashboardData = () => {
    let payload = {
      id: userId,
      date: day ? day : '',
    };
    getMettingCount((res) => {
      const { data, success, error } = res;

      if (success === true) {
        setMettingCountOpen({ ftd: data.open.ftd, mtd: data.open.mtd });
        setMettingCountHistory({
          ftd: data.history.ftd,
          mtd: data.history.mtd,
        });
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        setIsloading(false);
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
      }
      setIsloading(false);
    }, payload);
    getdealerCount((res) => {
      const { data, success, error } = res;
      if (success === true) {
        setDealerCount({
          approve: data.approve,
          pipeline: data.pipeline,
          reject: data.reject,
        });
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        setIsloading(false);
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
      }
      setIsloading(false);
    }, payload);
    getOrderSummaryCount((res) => {
      const { data, success, error } = res;
      if (success === true) {
        setOrderCount({ ftd: data.order.ftd, mtd: data.order.mtd });
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        setIsloading(false);
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
      }
      setIsloading(false);
    }, payload);
    getdealerEngagement((res) => {
      const { data, success, error } = res;
      if (success === true) {
        setDealerEngagement({
          bday: data.birthday,
          mAnniversary: data.marriage_anniversary,
          wAnniversary: data.work_anniversary,
        });
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        setIsloading(false);
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
      }
      setIsloading(false);
    }, payload);

    getdealerActiveInactiveCount((res) => {
      const { data, success, error } = res;
      if (success === true) {
        setDealerActiveInactiveCount({
          active: data.active,
          inactive: data.inactive,
        });
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        setIsloading(false);
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
      }
      setIsloading(false);
    }, payload);
  };

  useEffect(() => {
    setIsloading(true);
    getPerformanceInsightData();
  }, [userId, performanceYearId, performanceMonthId]);

  useEffect(() => {
    getAllUsers();
  }, []);

  const getAllUsers = () => {
    getSuccessors((res) => {
      const { data, success, error } = res;
      if (success === true) {
        setIsloading(false);
        setPruser(data);
      } else if (success === false || success === 'undefined') {
        setIsloading(false);
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
      }
      setIsloading(false);
    });
  };

  const getPerformanceInsightData = () => {
    let payload = {
      userId: userUUID,
      month: performanceMonthId,
      year: performanceYearId,
    };
    getPerformanceInsight((res) => {
      const { data, success, error } = res;
      if (success === true) {
        setWorkingDay(data.workingDays);
        setbalanceDay(data.balanceDays);
        setPerformance(data);
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        setIsloading(false);
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
      }
      setIsloading(false);
    }, payload);
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleChangePruser = (e) => {
    let val = e.target.value;
    setPruserId(val);
    setIsloading(true);
    let payload = {
      userId: val ? val : userUUID,
      month: performanceMonthId,
      year: performanceYearId,
    };
    getPerformanceInsight((res) => {
      const { data, success, error } = res;
      if (success === true) {
        setWorkingDay(data.workingDays);
        setbalanceDay(data.balanceDays);
        setPerformance(data);
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        setIsloading(false);
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
      }
      setIsloading(false);
    }, payload);
  };

  const setBreadcrumbsRecord = () => {
    Storage.setBreadcrumbsrRecord([
      {
        title: 'Dashboard',
        url: stringArr[0],
      },
    ]);
  };

  let tmUser = prUser.filter((elem) => elem.role === Roles.TM_NAME);
  let shUser = prUser.filter((elem) => elem.role === Roles.SH_NAME);
  let nhUser = prUser.filter((elem) => elem.role === Roles.NH_NAME);
  let bhUser = prUser.filter((elem) => elem.role === Roles.BH_NAME);

  const handleChangeFinancialYear = (e) => {
    setYear(e.target.value);
    if (e.target.value && e.target.value === moment().format('YYYY')) {
      const startOfMonth = moment()
        .startOf('month')
        .format('YYYY-MM-DD');
      const endOfMonth = moment()
        .endOf('month')
        .format('YYYY-MM-DD');
      setDay(moment().format('YYYY-MM-DD'));
      setSelectedFirstDate(startOfMonth);
      setSelectedLastDate(endOfMonth);
    } else {
      setDay(`${parseInt(e.target.value)}-04-01`);
      setSelectedFirstDate(`${parseInt(e.target.value)}-04-01`);
      setSelectedLastDate(`${parseInt(e.target.value)}-04-30`);
    }

    setPerformanceyearArr([
      {
        id: parseInt(e.target.value),
        yearName: parseInt(e.target.value),
      },
      {
        id: parseInt(e.target.value) + 1,
        yearName: parseInt(e.target.value) + 1,
      },
    ]);
    if (new Date().getFullYear().toString() === e.target.value || (new Date().getFullYear() - 1).toString() === e.target.value) {
      setPerformanceYearId(new Date().getFullYear());
      setPerformanceMonthId(new Date().getMonth() + 1)
    } else {
      setPerformanceYearId(e.target.value);
      setPerformanceMonthId('');
    }
  };

  const handleChangeDate = (e) => {
    setDay(e.target.value);
    e.target.value
      ? setSelectedFirstDate(
        `${moment(e.target.value).format('YYYY')}-${moment(
          e.target.value
        ).format('MM')}-01`
      )
      : setSelectedFirstDate('');
    e.target.value
      ? setSelectedLastDate(
        `${moment(e.target.value).format('YYYY')}-${moment(
          e.target.value
        ).format('MM')}-${moment(e.target.value, 'YYYY-MM-DD')
          .endOf('month')
          .format('D')}`
      )
      : setSelectedLastDate('');
  };

  return (
    <>
      <AppHeader />
      <div className='app-main'>
      <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id='dashboard'>
              {isLoading && <CustomSpinner />}
              <Container fluid>
                <Row>
                  <Col xs={12}>
                    <div className='pageheader'>
                      <DashBoardTitle dashBorardName='Dashboard' />
                      <div className='yearBlock'>
                        <Form>
                          <div className='d-flex flex-wrap align-items-center mb-0'>
                            <Label for='yearSelect' className='formLabel mb-1'>
                              Financial Year
                            </Label>
                            <Input
                              bsSize='sm'
                              type='select'
                              name='year'
                              id='year'
                              value={year}
                              // defaultValue={getFinancialYear().currentFinancialYear.split('-')[0]}
                              onChange={(e) => handleChangeFinancialYear(e)}
                              className='dashboardInput mb-0 fySelect'
                            >
                              {fYArr.length > 0 &&
                                fYArr.map((elem, index) => {
                                  return (
                                    <option value={elem.split('-')[0]} key={index}>
                                      {elem}
                                    </option>
                                  );
                                })}

                              {/* <option value='2018'>2018-19</option>
                  <option value='2019'>2019-20</option>
                  <option value='2020'>2020-21</option>
                  <option value='2021'>2021-22</option>
                  <option value='2022'>2022-23</option> */}
                            </Input>
                          </div>
                        </Form>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <div className='dashboardWorkArea'>
                      <div className='dashboardTabs' id='dashboardTabs'>
                        <Nav tabs>
                          <NavItem>
                            <NavLink
                              className={classnames({ active: activeTab === '1' })}
                              onClick={() => toggleTab('1')}
                            >
                              Task for the day
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              className={classnames({ active: activeTab === '2' })}
                              onClick={() => toggleTab('2')}
                            >
                              Performance
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              className={classnames({ active: activeTab === '3' })}
                              id='workingDay'
                            >
                              Working Days
                              <span className='font-weight-bold'>{workingDay}</span>
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              className={classnames({ active: activeTab === '4' })}
                              id='balanceDay'
                            >
                              {balanceday === 1 ? 'Balance Day' : 'Balance Days'}
                              <span className='font-weight-bold'>{balanceday}</span>
                            </NavLink>
                          </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab}>
                          <TabPane tabId='1'>
                            <div className='cardWrapper'>
                              <Row>
                                <Col>
                                  <Form className='d-flex dateSelect'>
                                    <FormGroup className='d-flex flex-wrap align-items-center mb-0'>
                                      <Label for='daySelect' className='formLabel'>
                                        Select Date
                                      </Label>
                                      <Input
                                        bsSize='sm'
                                        type='date'
                                        name='day'
                                        id='day'
                                        value={day}
                                        onChange={(e) => handleChangeDate(e)}
                                        className='dashboardInput'
                                        min={`${year}-04-01`}
                                        max={`${parseInt(year) + 1}-03-31`}
                                        onKeyDown={(e) => e.preventDefault()}
                                      />
                                    </FormGroup>
                                  </Form>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl={4} lg={6} md={6}>
                                  <div className='cardDashboard'>
                                    <div className='mainTitle m-0'>Dealer Meeting</div>
                                    <div className='cardDashboardInner'>
                                      <Row className='justify-content-center'>
                                        <Col>
                                          <NumberCardBlock
                                            handleParentClick={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              navigate(
                                                `/meeting/open-meeting-user-list`
                                              );
                                            }}
                                            onclickChildFtd={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              meetingCountOpen.ftd > 0 &&
                                                navigate({
                                                  pathname: `/meeting/open-meeting/ftd/${userId}`,
                                                });
                                            }}
                                            onclickChildMtd={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              meetingCountOpen.mtd > 0 &&
                                                navigate({
                                                  pathname: `/meeting/open-meeting/mtd/${userId}`,
                                                });
                                            }}
                                            heading='OPEN'
                                            ftdCount={meetingCountOpen.ftd}
                                            mtdCount={meetingCountOpen.mtd}
                                            ftdNumberColor='green'
                                            mtdumberColor='blue'
                                          />
                                        </Col>
                                        <Col>
                                          <NumberCardBlock
                                            handleParentClick={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              navigate(
                                                `/meeting/meeting-history-user-list`
                                              );
                                            }}
                                            onclickChildFtd={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              meetingCountHistory.ftd > 0 &&
                                                navigate({
                                                  pathname: `/meeting/meeting-history/ftd/${userId}`,
                                                });
                                            }}
                                            onclickChildMtd={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              meetingCountHistory.mtd > 0 &&
                                                navigate({
                                                  pathname: `/meeting/meeting-history/mtd/${userId}`,
                                                });
                                            }}
                                            heading='HISTORY'
                                            ftdCount={meetingCountHistory.ftd}
                                            mtdCount={meetingCountHistory.mtd}
                                            ftdNumberColor='green'
                                            mtdumberColor='blue'
                                          />
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </Col>
                                <Col xl={4} lg={6} md={6}>
                                  <div className={`cardDashboard`}>
                                    <div className='mainTitle m-0'>New Dealer Reg.</div>
                                    <div className='cardDashboardInner'>
                                      <Row className='justify-content-center'>
                                        <Col>
                                          <SingleCountBlock
                                            heightDeduct={true}
                                            handleParentClick={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              navigate(
                                                `/pages/pipeline-summary`
                                              );
                                            }}
                                            numberClick={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              dealerCount.pipeline > 0 &&
                                                navigate(
                                                  `/pages/pipeline/${userId}`
                                                );
                                            }}
                                            heading='PIPELINE'
                                            count={dealerCount.pipeline}
                                          />
                                        </Col>
                                        <Col>
                                          <SingleCountBlock
                                            heightDeduct={true}
                                            handleParentClick={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              navigate(
                                                `/pages/approved-app-summary`
                                              );
                                            }}
                                            numberClick={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              dealerCount.approve > 0 &&
                                                navigate(
                                                  `/pages/approved-app/${userId}`
                                                );
                                            }}
                                            heading='APPROVED'
                                            count={dealerCount.approve}
                                            countColor='green'
                                          />
                                        </Col>
                                        <Col>
                                          <SingleCountBlock
                                            heightDeduct={true}
                                            handleParentClick={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              navigate(
                                                `/pages/rejected-app-summary`
                                              );
                                            }}
                                            numberClick={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              dealerCount.reject > 0 &&
                                                navigate(
                                                  `/pages/rejected-app/${userId}`
                                                );
                                            }}
                                            heading='REJECTED'
                                            count={dealerCount.reject}
                                            countColor='red'
                                          />
                                        </Col>
                                        <Col xs={12}>
                                          <span className='filterNote'>
                                            Note : Date filter does not apply to this card{' '}
                                          </span>
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </Col>
                                <Col xl={4} lg={6} md={6}>
                                  <div className='cardDashboard'>
                                    <div className='mainTitle m-0'>Order Summary</div>
                                    <div className='cardDashboardInner'>
                                      <Row className='justify-content-center'>
                                        <Col>
                                          <SingleCountBlock
                                            handleParentClick={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              navigate(
                                                `/order/order-summary-user-list`
                                              );
                                            }}
                                            numberClick={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              orderCount.ftd > 0 &&
                                                navigate(
                                                  `/order/order-summary/ftd/${userId}`
                                                );
                                            }}
                                            heading='FTD'
                                            count={orderCount.ftd}
                                          />
                                        </Col>
                                        <Col>
                                          <SingleCountBlock
                                            handleParentClick={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              navigate(
                                                `/order/order-summary-user-list`
                                              );
                                            }}
                                            numberClick={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              orderCount.mtd > 0 &&
                                                navigate(
                                                  `/order/order-summary/mtd/${userId}`
                                                );
                                            }}
                                            heading='MTD'
                                            count={orderCount.mtd}
                                          />
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </Col>
                                <Col xl={4} lg={6} md={6}>
                                  <div className='cardDashboard'>
                                    <div className='mainTitle m-0'>Dealer Engagement</div>
                                    <div className='cardDashboardInner'>
                                      <Row className='justify-content-center'>
                                        <Col>
                                          <SingleCountBlock
                                            marginTop={true}
                                            handleParentClick={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              navigate(
                                                `/dealer/birth-day-summary`
                                              );
                                            }}
                                            numberClick={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              dealerEngagement.bday > 0 &&
                                                navigate(
                                                  `/dealer/birth-day/${userId}`
                                                );
                                            }}
                                            heading='Birthdays'
                                            count={dealerEngagement.bday}
                                          />
                                        </Col>
                                        <Col>
                                          <SingleCountBlock
                                            handleParentClick={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              navigate(
                                                `/dealer/m-anniversary-summary`
                                              );
                                            }}
                                            numberClick={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              dealerEngagement.mAnniversary > 0 &&
                                                navigate(
                                                  `/dealer/m-anniversary/${userId}`
                                                );
                                            }}
                                            heading="Marriage A'sary"
                                            count={dealerEngagement.mAnniversary}
                                            countColor='green'
                                          />
                                        </Col>
                                        <Col>
                                          <SingleCountBlock
                                            handleParentClick={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              navigate(
                                                `/dealer/work-anniversary-summary`
                                              );
                                            }}
                                            numberClick={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              dealerEngagement.wAnniversary > 0 &&
                                                navigate(
                                                  `/dealer/work-anniversary/${userId}`
                                                );
                                            }}
                                            heading="Work A'sary"
                                            count={dealerEngagement.wAnniversary}
                                            countColor='red'
                                          />
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </Col>
                                <Col xl={4} lg={6} md={6}>
                                  <div className='cardDashboard'>
                                    <div className='mainTitle m-0'>Dealer List</div>
                                    <div className='cardDashboardInner'>
                                      <Row className='justify-content-center'>
                                        <Col>
                                          <SingleCountBlock
                                            heightDeduct={true}
                                            handleParentClick={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              navigate(
                                                `/list/dealer-user-list`
                                              );
                                            }}
                                            numberClick={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              dealerActiveInactiveCount.active > 0 &&
                                                navigate({
                                                  pathname: `/list/dealer-list/active/${userId}`,
                                                });
                                            }}
                                            heading='ACTIVE'
                                            count={dealerActiveInactiveCount.active}
                                            countColor='green'
                                          />
                                        </Col>
                                        <Col>
                                          <SingleCountBlock
                                            heightDeduct={true}
                                            handleParentClick={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              navigate(
                                                `/list/dealer-user-list`
                                              );
                                            }}
                                            numberClick={(e) => {
                                              e.stopPropagation();
                                              setBreadcrumbsRecord();
                                              dealerActiveInactiveCount.inactive > 0 &&
                                                navigate({
                                                  pathname: `/list/dealer-list/inactive/${userId}`,
                                                });
                                            }}
                                            heading='INACTIVE'
                                            count={dealerActiveInactiveCount.inactive}
                                            countColor='red'
                                          />
                                        </Col>
                                        <Col xs={12}>
                                          {' '}
                                          <span className='filterNote'>
                                            Note : Date filter does not apply to this card{' '}
                                          </span>
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </TabPane>
                          <TabPane tabId='2'>
                            <div className='performanceWrapper'>
                              <Container fluid>
                                <Row className=''>
                                  <Col className='d-flex flex-wrap justify-content-end justify-content-between mb-2'>
                                    <div className='d-flex flex-wrap align-items-center mb-2 selectPerformanceBlock'>
                                      <div className='selectPerformance selectMonthYear'>
                                        <label htmlFor='selectYearP'>Year:</label>
                                        <br />
                                        <select
                                          name='selectYearP'
                                          id='selectYearP'
                                          value={performanceYearId}
                                          onChange={(e) => {
                                            setPerformanceYearId(e.target.value);
                                            setPerformanceMonthId('');
                                          }}
                                        >
                                          {/* <option value={''}>All</option> */}
                                          {performanceyearArr.length > 0 &&
                                            performanceyearArr.map((elem, index) => {
                                              const { id, yearName } = elem;
                                              return (
                                                <option value={id} key={index}>
                                                  {yearName}
                                                </option>
                                              );
                                            })}
                                        </select>
                                      </div>
                                      <div className='selectPerformance selectMonthYear'>
                                        <label htmlFor='selectMonthP'>Month:</label>
                                        <br />
                                        <select
                                          name='selectMonthP'
                                          id='selectMonthP'
                                          value={performanceMonthId}
                                          onChange={(e) => {
                                            setPerformanceMonthId(e.target.value)
                                          }}
                                        >
                                          <option value={''} disabled>
                                            Select
                                          </option>
                                          {filterMonthArr && filterMonthArr.length > 0 &&
                                            filterMonthArr.map((elem, index) => {
                                              const { id, monthName } = elem;
                                              return (
                                                <option value={id} key={index}>
                                                  {monthName}
                                                </option>
                                              );
                                            })}
                                        </select>
                                      </div>
                                    </div>
                                    <div className='d-flex flex-wrap align-items-center mb-2 selectPerformanceBlock'>
                                      <div className='selectPerformance'>
                                        {roleName !== Roles.TM_NAME && (
                                          <div className='userSelect'>
                                            <label htmlFor='userLabel'>Select User:</label>
                                            <br />
                                            <select
                                              className='selectpicker'
                                              value={prUserId}
                                              onChange={(e) => handleChangePruser(e)}
                                            >
                                              {/* <option value={0}>All</option> */}
                                              {bhUser.length > 0 && (
                                                <optgroup label='Business Head'>
                                                  {bhUser[0].users.map((elem, index) => {
                                                    return (
                                                      <option value={elem.uuid} key={index}>
                                                        {elem.first_name} {elem.last_name}
                                                      </option>
                                                    );
                                                  })}
                                                </optgroup>
                                              )}
                                              {nhUser.length > 0 && (
                                                <optgroup label='National Head'>
                                                  {nhUser[0].users.map((elem, index) => {
                                                    return (
                                                      <option value={elem.uuid} key={index}>
                                                        {elem.first_name} {elem.last_name}
                                                      </option>
                                                    );
                                                  })}
                                                </optgroup>
                                              )}
                                              {shUser.length > 0 && (
                                                <optgroup label='State Head'>
                                                  {shUser[0].users.map((elem, index) => {
                                                    return (
                                                      <option value={elem.uuid} key={index}>
                                                        {elem.first_name} {elem.last_name}
                                                      </option>
                                                    );
                                                  })}
                                                </optgroup>
                                              )}
                                              {tmUser.length > 0 && (
                                                <optgroup label='Territory Manager'>
                                                  {tmUser[0].users.map((elem, index) => {
                                                    return (
                                                      <option value={elem.uuid} key={index}>
                                                        {elem.first_name} {elem.last_name}
                                                      </option>
                                                    );
                                                  })}
                                                </optgroup>
                                              )}
                                            </select>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  {performance.goals
                                    ? performance.goals.map((elem, index) => {
                                      const {
                                        type,
                                        goal,
                                        achievement,
                                        drr,
                                        color,
                                        unit_type,
                                      } = elem;
                                      return (
                                        <Col xl={4} lg={6} sm={6} key={index}>
                                          <div
                                            className='cardPerformance'
                                            id='cardPerformance'
                                          >
                                            <div
                                              className={`mainTitle`}
                                              style={{ color: `${color}` }}
                                            >
                                              {type}
                                            </div>
                                            <div className='innerText d-flex flex-wrap justify-content-between mb-1'>
                                              <div>
                                                Goal{' '}
                                                <span className='font-weight-bold'>
                                                  {goal} {unit_type}
                                                </span>
                                              </div>
                                              <div>
                                                Achivement{' '}
                                                <span className='font-weight-bold'>
                                                  {achievement} {unit_type}
                                                </span>
                                              </div>
                                            </div>
                                            <div
                                              className='progress customProgress'
                                              style={{ maxWidth: '100%', height: '10px' }}
                                            >
                                              <div
                                                className='progress-bar'
                                                style={{
                                                  width: `${goal !== 0
                                                    ? (100 * achievement) / goal
                                                    : 0
                                                    }%`,
                                                  backgroundColor: `${color}`,
                                                }}
                                              ></div>
                                            </div>
                                            <div className='innerText d-flex flex-wrap justify-content-between mt-1'>
                                              <div>
                                                Shortfall{' '}
                                                {goal - achievement >= 0
                                                  ? (goal - achievement).toFixed(3)
                                                  : 0}{' '}
                                                {unit_type}
                                              </div>
                                              <div>
                                                DRR {drr} {unit_type}
                                              </div>
                                            </div>
                                          </div>
                                        </Col>
                                      );
                                    })
                                    : ''}
                                </Row>
                              </Container>
                            </div>
                          </TabPane>
                          {/* <TabPane tabId="3">
                <Row>
                  <Col sm="12">
                    <h4>
                      Tab 3 Contents
                    </h4>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="4">
                <Row>
                  <Col sm="12">
                    <h4>
                      Tab 4 Contents
                    </h4>
                  </Col>
                </Row>
              </TabPane> */}
                        </TabContent>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
